/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Design_Desc6Inputs */

const en_svc_mcp_server_development_design_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your SaaS or internal tool modeled as clean MCP tools and resources an agent can actually use.`)
};

const ar_svc_mcp_server_development_design_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منتجك SaaS أو أداتك الداخلية مصممة كأدوات وموارد MCP نظيفة يمكن للوكيل استخدامها فعلا.`)
};

const bn_svc_mcp_server_development_design_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার SaaS বা অভ্যন্তরীণ টুল পরিষ্কার MCP টুল আর রিসোর্স হিসেবে মডেল করা, যা এজেন্ট সত্যিই ব্যবহার করতে পারে।`)
};

const de_svc_mcp_server_development_design_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr SaaS oder internes Tool, modelliert als saubere MCP-Tools und Ressourcen, die ein Agent wirklich nutzen kann.`)
};

const es_svc_mcp_server_development_design_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su SaaS o herramienta interna modelada como herramientas y recursos MCP limpios que un agente puede usar de verdad.`)
};

const fr_svc_mcp_server_development_design_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre SaaS ou outil interne modélisé en outils et ressources MCP propres qu'un agent peut vraiment utiliser.`)
};

const pt_svc_mcp_server_development_design_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O seu SaaS ou ferramenta interna modelada como ferramentas e recursos MCP limpos que um agente pode usar a sério.`)
};

const zh_svc_mcp_server_development_design_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把你的 SaaS 或内部工具建模成干净的 MCP 工具和资源，让助手真正用得上。`)
};

const tr_svc_mcp_server_development_design_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SaaS ya da iç aracınız, bir ajanın gerçekten kullanacağı temiz MCP araç ve kaynakları olarak modellenir.`)
};

const ru_svc_mcp_server_development_design_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш SaaS или внутренний инструмент смоделирован как чистые MCP-инструменты и ресурсы, которыми агент реально может пользоваться.`)
};

const pl_svc_mcp_server_development_design_desc6 = /** @type {(inputs: Svc_Mcp_Server_Development_Design_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SaaS albo narzędzie wewnętrzne wymodelowane jako czyste narzędzia i zasoby MCP, których agent naprawdę może użyć.`)
};

/**
* | output |
* | --- |
* | "Your SaaS or internal tool modeled as clean MCP tools and resources an agent can actually use." |
*
* @param {Svc_Mcp_Server_Development_Design_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_design_desc6 = /** @type {((inputs?: Svc_Mcp_Server_Development_Design_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Design_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_design_desc6(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_design_desc6(inputs)
	if (locale === "de") return de_svc_mcp_server_development_design_desc6(inputs)
	if (locale === "es") return es_svc_mcp_server_development_design_desc6(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_design_desc6(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_design_desc6(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_design_desc6(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_design_desc6(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_design_desc6(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_design_desc6(inputs)
	return en_svc_mcp_server_development_design_desc6(inputs)
});
export { svc_mcp_server_development_design_desc6 as "svc_mcp-server-development_DESIGN_desc" }